import { USE_API_MOCKS } from '../env';
import { API_URL } from '@api/apiDictionary';
import { ModalityLabel } from '@dynamika-shared/types/imagingLabels';
import { RESTClient, RESTClientMock } from '@api/client';
import { fetchImagingLabelsMock } from '@api/mocks/imagingLabels';
import { replacePathParams } from '@utils/replacePathWithParams';

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export const fetchImagingLabels = async (clinicalTrialId?: string) => {
  if (USE_API_MOCKS) {
    fetchImagingLabelsMock();
  }
  return api.get<ModalityLabel[]>(API_URL.imagingLabels, {
    params: { name: clinicalTrialId },
  });
};

export const assignImagingLabelToCt = async (
  ctId: string,
  labels: string[]
) => {
  return api.post(replacePathParams(API_URL.ctLabels, { ctId }), { labels });
};
export const unassignImagingLabelFromCt = async (
  ctId: string,
  labelId: string
) => {
  return api.delete(replacePathParams(API_URL.ctLabelsLabel, { ctId, labelId }));
};
